module.exports = __webpack_public_path__ + "static/media/84.ed43e61a.mp3";